import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SimpleToggle, Typography } from '@dev/ee-components';
import { TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import { useGetSettingsInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetStep3Info';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { ToggleWrapper } from '../../../../../../styled';
import { useCampaignScreensPathsChecker } from '../../../../../../hooks/useCampaignScreensPathsChecker';

import { TimingToggleProps } from '../../../../../SettingsAndTrackingInterface';

export const TimingToggle = (props: TimingToggleProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { timingOption } = useGetSettingsInfo();
    const { timingOptToggle, setTimingOptToggle, setTiming } = props;
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const isTimingNone = timingOption === TimingOptionEnum.None;

    const changeToggle = (ev): void => {
        setTimingOptToggle(ev.target.checked);
        const modifyMap = new Map<string, any>();

        if (!ev.target.checked) {
            modifyMap.set('Options.TimingOption', TimingOptionEnum.None);
            dispatch(ModifyCampaignMap(modifyMap));
            setTiming(TimingOptionEnum.None);
            return;
        }

        modifyMap.set('Options.TimingOption', isTimingNone ? TimingOptionEnum.EngagedContactFirst : timingOption);
        dispatch(ModifyCampaignMap(modifyMap));
        setTiming(isTimingNone ? TimingOptionEnum.EngagedContactFirst : timingOption);
    };

    return (
        <ToggleWrapper>
            <SimpleToggle
                id="send-time-opt-toggle"
                value="sendtimeopt"
                checked={timingOptToggle}
                onChange={changeToggle}
                disabled={isDetailsScreen}
            />
            <Typography variant="h3">{t('sendtimeoptimization')}</Typography>
        </ToggleWrapper>
    );
};
